import { render } from "./GameRulesParity.vue?vue&type=template&id=3c6c1168&scoped=true"
import script from "./GameRulesParity.vue?vue&type=script&lang=js"
export * from "./GameRulesParity.vue?vue&type=script&lang=js"

import "./GameRulesParity.vue?vue&type=style&index=0&id=3c6c1168&scoped=true&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c6c1168"]])

export default __exports__